<script setup lang="ts">
import { useAuthStore } from '@/store/auth.ts'
import { useNoticeStore } from '@/store/notice.ts'

const auth = useAuthStore()
const notice = useNoticeStore()
</script>

<template>
  <Transition name="notice" appear>
    <aside v-if="notice.content" :class="['notice', { '--offset': auth.user.id !== '0' }]">
      <i
        v-if="notice.content.type === 'error'"
        class="material-icons notice__warning"
        style="color: #8b0000"
        >error</i
      >
      <i
        v-if="notice.content.type === 'info'"
        class="material-icons notice__warning"
        style="color: #041e42"
        >info</i
      >
      <i
        v-if="notice.content.type === 'success'"
        class="material-icons notice__warning"
        style="color: #006400"
        >check</i
      >
      <i
        v-if="notice.content.type === 'warning'"
        class="material-icons notice__warning"
        style="color: #d5b60a"
        >warning</i
      >
      <span>{{ notice.content.message }}</span>
      <button
        v-if="!notice.content.ttl"
        @click.stop="notice.clear()"
        type="button"
        :title="$t('close')"
        class="notice__close"
      >
        <i class="material-icons">close</i>
      </button>
      <div
        v-if="notice.content.ttl"
        class="notice__progress"
        :style="`--notice-duration: ${notice.content.ttl}ms;`"
      >
        <div class="notice__progress-bar"></div>
      </div>
    </aside>
  </Transition>
</template>
